import type { HelpArticle, HelpCategoryId } from "./types";

export const HELP_CATEGORIES: HelpCategoryId[] = [
    "getting_started",
    "overview",
    "players",
    "screening",
    "calendar",
    "courses",
    "economy",
    "campaigns",
    "statistics",
    "education",
    "settings",
    "admin",
    "account",
];

export const helpArticles: HelpArticle[] = [
    {
        id: "getting_started",
        category: "getting_started",
        titleKey: "help.articles.getting_started.title",
        routes: [],
        sections: [
            { headingKey: "help.articles.getting_started.s1.h", bodyKey: "help.articles.getting_started.s1.b" },
            { headingKey: "help.articles.getting_started.s2.h", bodyKey: "help.articles.getting_started.s2.b" },
            { headingKey: "help.articles.getting_started.s3.h", bodyKey: "help.articles.getting_started.s3.b" },
        ],
    },
    {
        id: "overview",
        category: "overview",
        titleKey: "help.articles.overview.title",
        routes: ["/"],
        sections: [
            { headingKey: "help.articles.overview.s1.h", bodyKey: "help.articles.overview.s1.b" },
            { headingKey: "help.articles.overview.s2.h", bodyKey: "help.articles.overview.s2.b" },
            { headingKey: "help.articles.overview.s3.h", bodyKey: "help.articles.overview.s3.b" },
        ],
    },
    {
        id: "tasks",
        category: "overview",
        titleKey: "help.articles.tasks.title",
        routes: ["/tasks"],
        sections: [
            { headingKey: "help.articles.tasks.s1.h", bodyKey: "help.articles.tasks.s1.b" },
            { headingKey: "help.articles.tasks.s2.h", bodyKey: "help.articles.tasks.s2.b" },
        ],
    },
    {
        id: "players_list",
        category: "players",
        titleKey: "help.articles.players_list.title",
        routes: ["/players"],
        sections: [
            { headingKey: "help.articles.players_list.s1.h", bodyKey: "help.articles.players_list.s1.b" },
            { headingKey: "help.articles.players_list.s2.h", bodyKey: "help.articles.players_list.s2.b" },
            { headingKey: "help.articles.players_list.s3.h", bodyKey: "help.articles.players_list.s3.b" },
        ],
    },
    {
        id: "player_new",
        category: "players",
        titleKey: "help.articles.player_new.title",
        routes: ["/player/new", "/player/edit/:id"],
        sections: [
            { headingKey: "help.articles.player_new.s1.h", bodyKey: "help.articles.player_new.s1.b" },
            { headingKey: "help.articles.player_new.s2.h", bodyKey: "help.articles.player_new.s2.b" },
        ],
    },
    {
        id: "player_card",
        category: "players",
        titleKey: "help.articles.player_card.title",
        routes: [
            "/player/",
            "/player/summery/:id",
            "/player/screening/:id",
            "/player/measurements/:id",
            "/player/action-plan/:id",
            "/player/training-plan/:id",
            "/player/activity/:id",
        ],
        sections: [
            { headingKey: "help.articles.player_card.s1.h", bodyKey: "help.articles.player_card.s1.b" },
            { headingKey: "help.articles.player_card.s2.h", bodyKey: "help.articles.player_card.s2.b" },
            { headingKey: "help.articles.player_card.s3.h", bodyKey: "help.articles.player_card.s3.b" },
            { headingKey: "help.articles.player_card.s4.h", bodyKey: "help.articles.player_card.s4.b" },
        ],
    },
    {
        id: "player_appointments",
        category: "players",
        titleKey: "help.articles.player_appointments.title",
        routes: ["/player/:id/appointments"],
        sections: [
            { headingKey: "help.articles.player_appointments.s1.h", bodyKey: "help.articles.player_appointments.s1.b" },
            { headingKey: "help.articles.player_appointments.s2.h", bodyKey: "help.articles.player_appointments.s2.b" },
        ],
    },
    {
        id: "player_packages",
        category: "players",
        titleKey: "help.articles.player_packages.title",
        routes: ["/player/:id/packages"],
        sections: [
            { headingKey: "help.articles.player_packages.s1.h", bodyKey: "help.articles.player_packages.s1.b" },
            { headingKey: "help.articles.player_packages.s2.h", bodyKey: "help.articles.player_packages.s2.b" },
        ],
    },
    {
        id: "player_messages",
        category: "players",
        titleKey: "help.articles.player_messages.title",
        routes: ["/player/:id/messages"],
        sections: [
            { headingKey: "help.articles.player_messages.s1.h", bodyKey: "help.articles.player_messages.s1.b" },
            { headingKey: "help.articles.player_messages.s2.h", bodyKey: "help.articles.player_messages.s2.b" },
        ],
    },
    {
        id: "player_forms",
        category: "players",
        titleKey: "help.articles.player_forms.title",
        routes: [
            "/player/assessment-form/:player_id",
            "/player/goal-form/:player_id/:goal_id?",
            "/player/medical-form/:player_id/:medical_id?",
            "/player/training-form/:player_id/:training_id?",
        ],
        sections: [
            { headingKey: "help.articles.player_forms.s1.h", bodyKey: "help.articles.player_forms.s1.b" },
            { headingKey: "help.articles.player_forms.s2.h", bodyKey: "help.articles.player_forms.s2.b" },
        ],
    },
    {
        id: "screening_result",
        category: "screening",
        titleKey: "help.articles.screening_result.title",
        routes: [
            "/player/screening-result/:id",
            "/player/screening-result/:id/measurements",
            "/player/screening-result/:id/action-plan",
            "/player/screening-result/:id/recommendations",
        ],
        sections: [
            { headingKey: "help.articles.screening_result.s1.h", bodyKey: "help.articles.screening_result.s1.b" },
            { headingKey: "help.articles.screening_result.s2.h", bodyKey: "help.articles.screening_result.s2.b" },
            { headingKey: "help.articles.screening_result.s3.h", bodyKey: "help.articles.screening_result.s3.b" },
        ],
    },
    {
        id: "screening_start",
        category: "screening",
        titleKey: "help.articles.screening_start.title",
        routes: ["/screening", "/screening-form/:id"],
        sections: [
            { headingKey: "help.articles.screening_start.s1.h", bodyKey: "help.articles.screening_start.s1.b" },
            { headingKey: "help.articles.screening_start.s2.h", bodyKey: "help.articles.screening_start.s2.b" },
        ],
    },
    {
        id: "screening_ai",
        category: "screening",
        titleKey: "help.articles.screening_ai.title",
        routes: [
            "/screening-ai",
            "/screening-ai/:id",
            "/screening-ai/:id/measurements",
            "/screening-ai/:id/recommendations",
            "/screening-ai/:id/action-plan",
        ],
        sections: [
            { headingKey: "help.articles.screening_ai.s1.h", bodyKey: "help.articles.screening_ai.s1.b" },
            { headingKey: "help.articles.screening_ai.s2.h", bodyKey: "help.articles.screening_ai.s2.b" },
            { headingKey: "help.articles.screening_ai.s3.h", bodyKey: "help.articles.screening_ai.s3.b" },
        ],
    },
    {
        id: "calendar",
        category: "calendar",
        titleKey: "help.articles.calendar.title",
        routes: ["/calendar"],
        sections: [
            { headingKey: "help.articles.calendar.s1.h", bodyKey: "help.articles.calendar.s1.b" },
            { headingKey: "help.articles.calendar.s2.h", bodyKey: "help.articles.calendar.s2.b" },
            { headingKey: "help.articles.calendar.s3.h", bodyKey: "help.articles.calendar.s3.b" },
            { headingKey: "help.articles.calendar.s4.h", bodyKey: "help.articles.calendar.s4.b" },
        ],
    },
    {
        id: "courses",
        category: "courses",
        titleKey: "help.articles.courses.title",
        routes: ["/courses", "/course/:id?", "/course/form/:id?", "/course/:id/payment"],
        sections: [
            { headingKey: "help.articles.courses.s1.h", bodyKey: "help.articles.courses.s1.b" },
            { headingKey: "help.articles.courses.s2.h", bodyKey: "help.articles.courses.s2.b" },
            { headingKey: "help.articles.courses.s3.h", bodyKey: "help.articles.courses.s3.b" },
        ],
    },
    {
        id: "economy",
        category: "economy",
        titleKey: "help.articles.economy.title",
        routes: [
            "/economy",
            "/economy/unpaid",
            "/economy/paid",
            "/economy/failed",
            "/economy/statistics",
        ],
        sections: [
            { headingKey: "help.articles.economy.s1.h", bodyKey: "help.articles.economy.s1.b" },
            { headingKey: "help.articles.economy.s2.h", bodyKey: "help.articles.economy.s2.b" },
            { headingKey: "help.articles.economy.s3.h", bodyKey: "help.articles.economy.s3.b" },
            { headingKey: "help.articles.economy.s4.h", bodyKey: "help.articles.economy.s4.b" },
            { headingKey: "help.articles.economy.s5.h", bodyKey: "help.articles.economy.s5.b" },
            { headingKey: "help.articles.economy.s6.h", bodyKey: "help.articles.economy.s6.b" },
        ],
    },
    {
        id: "campaigns",
        category: "campaigns",
        titleKey: "help.articles.campaigns.title",
        routes: ["/campaigns", "/campaigns/new", "/campaigns/:id"],
        sections: [
            { headingKey: "help.articles.campaigns.s1.h", bodyKey: "help.articles.campaigns.s1.b" },
            { headingKey: "help.articles.campaigns.s2.h", bodyKey: "help.articles.campaigns.s2.b" },
            { headingKey: "help.articles.campaigns.s3.h", bodyKey: "help.articles.campaigns.s3.b" },
        ],
    },
    {
        id: "email_templates",
        category: "campaigns",
        titleKey: "help.articles.email_templates.title",
        routes: ["/email-templates", "/email-templates/create", "/email-templates/:id"],
        sections: [
            { headingKey: "help.articles.email_templates.s1.h", bodyKey: "help.articles.email_templates.s1.b" },
            { headingKey: "help.articles.email_templates.s2.h", bodyKey: "help.articles.email_templates.s2.b" },
        ],
    },
    {
        id: "statistics",
        category: "statistics",
        titleKey: "help.articles.statistics.title",
        routes: ["/statistics"],
        sections: [
            { headingKey: "help.articles.statistics.s1.h", bodyKey: "help.articles.statistics.s1.b" },
            { headingKey: "help.articles.statistics.s2.h", bodyKey: "help.articles.statistics.s2.b" },
        ],
    },
    {
        id: "education",
        category: "education",
        titleKey: "help.articles.education.title",
        routes: ["/education"],
        sections: [
            { headingKey: "help.articles.education.s1.h", bodyKey: "help.articles.education.s1.b" },
            { headingKey: "help.articles.education.s2.h", bodyKey: "help.articles.education.s2.b" },
        ],
    },
    {
        id: "settings_overview",
        category: "settings",
        titleKey: "help.articles.settings_overview.title",
        routes: ["/settings", "/settings/overview"],
        sections: [
            { headingKey: "help.articles.settings_overview.s1.h", bodyKey: "help.articles.settings_overview.s1.b" },
            { headingKey: "help.articles.settings_overview.s2.h", bodyKey: "help.articles.settings_overview.s2.b" },
        ],
    },
    {
        id: "settings_services",
        category: "settings",
        titleKey: "help.articles.settings_services.title",
        routes: ["/settings/service/form", "/settings/service/form/:id"],
        sections: [
            { headingKey: "help.articles.settings_services.s1.h", bodyKey: "help.articles.settings_services.s1.b" },
            { headingKey: "help.articles.settings_services.s2.h", bodyKey: "help.articles.settings_services.s2.b" },
        ],
    },
    {
        id: "settings_packages",
        category: "settings",
        titleKey: "help.articles.settings_packages.title",
        routes: ["/settings/package/form/:id?"],
        sections: [
            { headingKey: "help.articles.settings_packages.s1.h", bodyKey: "help.articles.settings_packages.s1.b" },
            { headingKey: "help.articles.settings_packages.s2.h", bodyKey: "help.articles.settings_packages.s2.b" },
        ],
    },
    {
        id: "settings_promo_codes",
        category: "settings",
        titleKey: "help.articles.settings_promo_codes.title",
        routes: ["/settings/promo-code/form/:id?"],
        sections: [
            { headingKey: "help.articles.settings_promo_codes.s1.h", bodyKey: "help.articles.settings_promo_codes.s1.b" },
            { headingKey: "help.articles.settings_promo_codes.s2.h", bodyKey: "help.articles.settings_promo_codes.s2.b" },
        ],
    },
    {
        id: "settings_equipment",
        category: "settings",
        titleKey: "help.articles.settings_equipment.title",
        routes: [
            "/settings/equipment/form",
            "/settings/equipment/form/:id",
            "/settings/equipment/:equipmentId/schedules",
            "/settings/equipment/:equipmentId/schedules/form",
            "/settings/equipment/:equipmentId/schedules/form/:scheduleId",
            "/settings/equipment/:equipmentId/pricing",
            "/settings/equipment/:equipmentId/pricing/form",
            "/settings/equipment/:equipmentId/pricing/form/:id",
        ],
        sections: [
            { headingKey: "help.articles.settings_equipment.s1.h", bodyKey: "help.articles.settings_equipment.s1.b" },
            { headingKey: "help.articles.settings_equipment.s2.h", bodyKey: "help.articles.settings_equipment.s2.b" },
            { headingKey: "help.articles.settings_equipment.s3.h", bodyKey: "help.articles.settings_equipment.s3.b" },
        ],
    },
    {
        id: "settings_schedule",
        category: "settings",
        titleKey: "help.articles.settings_schedule.title",
        routes: ["/settings/schedule"],
        sections: [
            { headingKey: "help.articles.settings_schedule.s1.h", bodyKey: "help.articles.settings_schedule.s1.b" },
            { headingKey: "help.articles.settings_schedule.s2.h", bodyKey: "help.articles.settings_schedule.s2.b" },
        ],
    },
    {
        id: "settings_users",
        category: "settings",
        titleKey: "help.articles.settings_users.title",
        routes: ["/settings/users"],
        sections: [
            { headingKey: "help.articles.settings_users.s1.h", bodyKey: "help.articles.settings_users.s1.b" },
            { headingKey: "help.articles.settings_users.s2.h", bodyKey: "help.articles.settings_users.s2.b" },
        ],
    },
    {
        id: "settings_payment_receivers",
        category: "settings",
        titleKey: "help.articles.settings_payment_receivers.title",
        routes: [
            "/settings/payment-receivers",
            "/settings/payment-receivers/form",
            "/settings/payment-receivers/form/:id",
        ],
        sections: [
            { headingKey: "help.articles.settings_payment_receivers.s1.h", bodyKey: "help.articles.settings_payment_receivers.s1.b" },
            { headingKey: "help.articles.settings_payment_receivers.s2.h", bodyKey: "help.articles.settings_payment_receivers.s2.b" },
        ],
    },
    {
        id: "settings_payment_gateway",
        category: "settings",
        titleKey: "help.articles.settings_payment_gateway.title",
        routes: [
            "/settings/payment-gateway",
            "/settings/:paymentReceiverId/payment-gateway",
            "/settings/:paymentReceiverId/payment-gateway/config/swish",
            "/settings/:paymentReceiverId/payment-gateway/config/at_club",
            "/settings/:paymentReceiverId/payment-gateway/config/stripe",
            "/settings/:paymentReceiverId/payment-gateway/config/paypal",
            "/settings/:paymentReceiverId/payment-gateway/config/revolut",
            "/settings/payment-gateway/config/swish",
            "/settings/payment-gateway/config/at_club",
            "/settings/payment-gateway/config/stripe",
            "/settings/payment-gateway/config/paypal",
            "/settings/payment-gateway/config/revolut",
        ],
        sections: [
            { headingKey: "help.articles.settings_payment_gateway.s1.h", bodyKey: "help.articles.settings_payment_gateway.s1.b" },
            { headingKey: "help.articles.settings_payment_gateway.s2.h", bodyKey: "help.articles.settings_payment_gateway.s2.b" },
            { headingKey: "help.articles.settings_payment_gateway.s3.h", bodyKey: "help.articles.settings_payment_gateway.s3.b" },
        ],
    },
    {
        id: "settings_text_templates",
        category: "settings",
        titleKey: "help.articles.settings_text_templates.title",
        routes: ["/settings/text-template"],
        sections: [
            { headingKey: "help.articles.settings_text_templates.s1.h", bodyKey: "help.articles.settings_text_templates.s1.b" },
            { headingKey: "help.articles.settings_text_templates.s2.h", bodyKey: "help.articles.settings_text_templates.s2.b" },
        ],
    },
    {
        id: "settings_booking_system",
        category: "settings",
        titleKey: "help.articles.settings_booking_system.title",
        routes: ["/settings/booking-system"],
        sections: [
            { headingKey: "help.articles.settings_booking_system.s1.h", bodyKey: "help.articles.settings_booking_system.s1.b" },
            { headingKey: "help.articles.settings_booking_system.s2.h", bodyKey: "help.articles.settings_booking_system.s2.b" },
        ],
    },
    {
        id: "settings_billing",
        category: "settings",
        titleKey: "help.articles.settings_billing.title",
        routes: ["/settings/billing"],
        sections: [
            { headingKey: "help.articles.settings_billing.s1.h", bodyKey: "help.articles.settings_billing.s1.b" },
            { headingKey: "help.articles.settings_billing.s2.h", bodyKey: "help.articles.settings_billing.s2.b" },
        ],
    },
    {
        id: "settings_organisation",
        category: "settings",
        titleKey: "help.articles.settings_organisation.title",
        routes: ["/settings/organisation/edit"],
        sections: [
            { headingKey: "help.articles.settings_organisation.s1.h", bodyKey: "help.articles.settings_organisation.s1.b" },
            { headingKey: "help.articles.settings_organisation.s2.h", bodyKey: "help.articles.settings_organisation.s2.b" },
        ],
    },
    {
        id: "profile",
        category: "account",
        titleKey: "help.articles.profile.title",
        routes: ["/profile", "/profile/ical"],
        sections: [
            { headingKey: "help.articles.profile.s1.h", bodyKey: "help.articles.profile.s1.b" },
            { headingKey: "help.articles.profile.s2.h", bodyKey: "help.articles.profile.s2.b" },
        ],
    },
    {
        id: "subscription",
        category: "account",
        titleKey: "help.articles.subscription.title",
        routes: ["/subscription"],
        sections: [
            { headingKey: "help.articles.subscription.s1.h", bodyKey: "help.articles.subscription.s1.b" },
            { headingKey: "help.articles.subscription.s2.h", bodyKey: "help.articles.subscription.s2.b" },
        ],
    },
    {
        id: "notifications",
        category: "account",
        titleKey: "help.articles.notifications.title",
        routes: ["/notifications"],
        sections: [
            { headingKey: "help.articles.notifications.s1.h", bodyKey: "help.articles.notifications.s1.b" },
            { headingKey: "help.articles.notifications.s2.h", bodyKey: "help.articles.notifications.s2.b" },
        ],
    },
    {
        id: "chat",
        category: "account",
        titleKey: "help.articles.chat.title",
        routes: ["/chat"],
        sections: [
            { headingKey: "help.articles.chat.s1.h", bodyKey: "help.articles.chat.s1.b" },
            { headingKey: "help.articles.chat.s2.h", bodyKey: "help.articles.chat.s2.b" },
        ],
    },
    {
        id: "support_hub",
        category: "getting_started",
        titleKey: "help.articles.support_hub.title",
        routes: [
            "/support",
            "/support/guides/booking-get-started",
            "/support/guides/install-ios",
        ],
        sections: [
            { headingKey: "help.articles.support_hub.s1.h", bodyKey: "help.articles.support_hub.s1.b" },
            { headingKey: "help.articles.support_hub.s2.h", bodyKey: "help.articles.support_hub.s2.b" },
        ],
    },
    {
        id: "admin_overview",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_overview.title",
        routes: ["/admin", "/admin/overview"],
        sections: [
            { headingKey: "help.articles.admin_overview.s1.h", bodyKey: "help.articles.admin_overview.s1.b" },
            { headingKey: "help.articles.admin_overview.s2.h", bodyKey: "help.articles.admin_overview.s2.b" },
        ],
    },
    {
        id: "admin_organisations",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_organisations.title",
        routes: [
            "/admin/organisation",
            "/admin/organisation/form/:id?",
            "/admin/organisation/:id/users",
            "/admin/organisation/:id/subscription",
        ],
        sections: [
            { headingKey: "help.articles.admin_organisations.s1.h", bodyKey: "help.articles.admin_organisations.s1.b" },
            { headingKey: "help.articles.admin_organisations.s2.h", bodyKey: "help.articles.admin_organisations.s2.b" },
        ],
    },
    {
        id: "admin_facilities",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_facilities.title",
        routes: ["/admin/facilitys", "/admin/facility/form/:id?"],
        sections: [
            { headingKey: "help.articles.admin_facilities.s1.h", bodyKey: "help.articles.admin_facilities.s1.b" },
            { headingKey: "help.articles.admin_facilities.s2.h", bodyKey: "help.articles.admin_facilities.s2.b" },
        ],
    },
    {
        id: "admin_users_invites",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_users_invites.title",
        routes: ["/admin/users", "/admin/invites", "/admin/bodytypes"],
        sections: [
            { headingKey: "help.articles.admin_users_invites.s1.h", bodyKey: "help.articles.admin_users_invites.s1.b" },
            { headingKey: "help.articles.admin_users_invites.s2.h", bodyKey: "help.articles.admin_users_invites.s2.b" },
        ],
    },
    {
        id: "admin_integrations",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_integrations.title",
        routes: ["/admin/integrations", "/admin/fortnox/callback"],
        sections: [
            { headingKey: "help.articles.admin_integrations.s1.h", bodyKey: "help.articles.admin_integrations.s1.b" },
            { headingKey: "help.articles.admin_integrations.s2.h", bodyKey: "help.articles.admin_integrations.s2.b" },
        ],
    },
    {
        id: "admin_misc",
        category: "admin",
        adminOnly: true,
        titleKey: "help.articles.admin_misc.title",
        routes: [
            "/admin/statistic",
            "/admin/price-lists",
            "/admin/promotion-codes",
            "/admin/bg-courses",
            "/admin/subscriptions",
        ],
        sections: [
            { headingKey: "help.articles.admin_misc.s1.h", bodyKey: "help.articles.admin_misc.s1.b" },
            { headingKey: "help.articles.admin_misc.s2.h", bodyKey: "help.articles.admin_misc.s2.b" },
        ],
    },
];

export const FALLBACK_ARTICLE_ID = "overview";
